export default (props, vars) =>
  !props?.['isOutstanding'] &&
  !!vars?.['uselookbook2']?.['lookbook']?.['about']?.['first_start_date'] &&
  !!vars?.['uselookbook2']?.['lookbook']?.['about']?.['last_end_date'];
